import script from "./ChevronArrowDown1Icon.vue?vue&type=script&setup=true&lang=js"
export * from "./ChevronArrowDown1Icon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__